export enum UserRoles {
    admin = 1,
    owner = 100,
    employee = 200
}
